/**
 * Workflows P5-4 (DEC-098): how a step can leave, as path analysis counts it. Mirrors backend `STEP_OUTCOMES`
 * (`app/core/constants/workflow_p5.py`): the `outcome` each step type writes to the run log, in the order the table shows
 * them. A step type that leaves in more than one way adds its row here and in the Python table.
 */
export const STEP_OUTCOMES = {
  let_assistant_answer: ["answered", "could_not_answer", "asked_for_person"],
  show_booking: ["done", "not_done"],
  show_lead_form: ["done", "not_done"],
  wait_for_webhook: ["received", "timed_out"],
  collect_reply: ["replied", "no_reply", "invalid"],
  snooze: ["woke", "interrupted", "skipped"],
  wait: ["woke", "interrupted"],
  http_request: ["success", "failure"],
  verify_email: ["verified", "failed", "expired"],
  show_article: ["shown", "skipped"],
  add_summary_note: ["written", "skipped", "errored"],
} as const satisfies Readonly<Record<string, readonly string[]>>;

/** How the assistant's answer went, as the Preview lets the author choose it (`POST /v1/workflows/{id}/preview/outcome`). */
export const ASSISTANT_OUTCOMES = STEP_OUTCOMES.let_assistant_answer;
export type AssistantOutcome = (typeof ASSISTANT_OUTCOMES)[number];
